import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import LoginTab from './LoginTab';
import { readPreferredLoginMethod, savePreferredLoginMethod } from './preferredLoginMethod';
import { LoginTabPickedByUser } from './loginTabPickedByUser';

const TABS_HIDDEN_ON_MOBILE_SHOWN_FROM = '(min-width: 768px)';

const isShownAtThisWidth = (child) =>
  !child.props.hideOnMobile || window.matchMedia(TABS_HIDDEN_ON_MOBILE_SHOWN_FROM).matches;

function initialTab(children) {
  const labels = children.map((child) => child.props.label);
  const shownLabels = children.filter(isShownAtThisWidth).map((child) => child.props.label);
  const preferred = readPreferredLoginMethod();
  return shownLabels.includes(preferred) ? preferred : labels[0];
}

class LoginTabs extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Array).isRequired,
    onTabChange: PropTypes.func,
  };

  static defaultProps = {
    onTabChange: () => undefined,
  };

  panelRef = createRef();

  // eslint-disable-next-line react/destructuring-assignment
  state = { activeTab: initialTab(this.props.children), pickedByUser: false };

  componentDidUpdate(_prevProps, { activeTab: prevActiveTab }) {
    const { activeTab } = this.state;
    if (prevActiveTab !== activeTab) {
      this.panelRef.current?.focus();
    }
  }

  onClickTabItem = (tab) => {
    const { onTabChange } = this.props;
    savePreferredLoginMethod(tab);
    this.setState({ activeTab: tab, pickedByUser: true });
    onTabChange();
  };

  render() {
    const {
      props: { children },
      state: { activeTab, pickedByUser },
      onClickTabItem,
    } = this;

    return (
      <>
        <ul className="mt-4 mt-sm-5 mb-4 nav nav-tabs nav-fill" role="tablist">
          {React.Children.map(children, (child) => {
            const { label, hideOnMobile } = child.props;

            return (
              <LoginTab
                activeTab={activeTab}
                key={label}
                label={label}
                onClick={onClickTabItem}
                hideOnMobile={hideOnMobile}
              />
            );
          })}
        </ul>
        <div
          className="tab-content"
          role="tabpanel"
          tabIndex="-1"
          aria-live="polite"
          ref={this.panelRef}
        >
          <LoginTabPickedByUser.Provider value={pickedByUser}>
            {React.Children.map(children, (child) => {
              if (child.props.label !== activeTab) {
                return undefined;
              }
              return child.props.children;
            })}
          </LoginTabPickedByUser.Provider>
        </div>
      </>
    );
  }
}

export default LoginTabs;
